import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import axios from 'axios';
import baseURL from '../url';
import './Cart.css';
import whatsappIcon from '../../images/wpp.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moneda from '../moneda';
import Swal from 'sweetalert2';
import contador from '../contador';
import MiPedido from '../MiPedido/MiPedido';
import { usePais } from '../usePais';

export default function Cart() {
    const { esCuba, errorGeo } = usePais();
    const [cartItems, setCartItems] = useState([]);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen2, setModalIsOpen2] = useState(false);
    const [modalIsOpen3, setModalIsOpen3] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [noteText, setNoteText] = useState('');
    const [costMensajeria, setcostMensajeria] = useState('');
    const [location, setLocation] = useState('');
    const [name, setName] = useState('');
    const [direccion, setDireccion] = useState('');
    const [numTelefono, setNumTelefono] = useState('');
    const [codigo, setCodigo] = useState('');
    const [contactos, setContactos] = useState([]);
    const [count, setCount] = useState(null);
    const [descuento, setDescuento] = useState(0);
    const [codigoValido, setCodigoValido] = useState(false);
    const [totalPrice, setTotalPrice] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('Efectivo');
    const [deliveryOption, setDeliveryOption] = useState('delivery');
    const [number, setNumber] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        cargarContacto();
        cargarMesas();
    }, []);

    useEffect(() => {
        let totalPriceCalc = 0;
        cartItems.forEach(item => {
            totalPriceCalc += (esCuba ? item.precio_cup : item.precio) * item.cantidad;
        });
        setTotalPrice(totalPriceCalc);
    }, [cartItems]);

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setContactos(data.contacto.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    useEffect(() => {
        cargarProductos();
    }, [isFocused]);

    useEffect(() => {
        const fetchCartItems = async () => {
            const cart = JSON.parse(localStorage.getItem('cart')) || [];
            const promises = cart.map(async (cartItem) => {
                const producto = productos.find(producto => producto.idProducto === cartItem.idProducto);
                return {
                    ...producto,
                    cantidad: cartItem.cantidad,
                    item: cartItem.item,
                };
            });

            Promise.all(promises)
                .then((items) => {
                    setCartItems(items);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error al obtener detalles del carrito:', error);
                    setLoading(false);
                });
        };

        fetchCartItems();
    }, [productos, isFocused]);

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const obtenerImagen = (item) => {
        return item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || null;
    };

    const openModal = () => {
        setModalIsOpen(true);
        setIsFocused(true);
        cargarMesas();
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setIsFocused(false);
    };

    const openModal2 = () => {
        setModalIsOpen2(true);
    };

    const closeModal2 = () => {
        setModalIsOpen2(false);
    };

    const openModal3 = () => {
        setModalIsOpen3(true);
    };

    const closeModal3 = () => {
        setModalIsOpen3(false);
    };

    const removeFromCart = (id) => {
        const updatedCart = cartItems.filter(item => item.idProducto !== id);
        setCartItems(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
    };

    const clearCart = () => {
        setCartItems([]);
        localStorage.removeItem('cart');
    };

    const [codigos, setCodigos] = useState([]);

    useEffect(() => {
        cargarCodigos();
    }, []);

    const cargarCodigos = () => {
        fetch(`${baseURL}/codigosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCodigos(data.codigos || []);
            })
            .catch(error => console.error('Error al cargar códigos:', error));
    };

    const handleWhatsappMessage = async () => {
    const codigoDescuento = codigos.find(item => item.codigo === codigo);
    let descuentoActualizado = 0;

    if (codigoDescuento) {
        descuentoActualizado = codigoDescuento.descuento;
        setCodigoValido(true);
    } else {
        setCodigoValido(false);
    }

    let totalPrice = 0;
    cartItems.forEach(item => {
        totalPrice += (esCuba ? item.precio_cup : item.precio) * item.cantidad;
    });

    let totalPriceWithDiscount = totalPrice - descuentoActualizado;
    if (totalPriceWithDiscount < 0) {
        totalPriceWithDiscount = 0;
    }

    const formattedTotalPrice = totalPriceWithDiscount.toFixed(2);

    let recargoTransferencia = 0;
    if (esCuba && paymentMethod === 'Transferencia') {
        recargoTransferencia = totalPriceWithDiscount * 0.10;
    }

    const phoneNumber = `${contactos.telefono}`;

    const cartDetails = cartItems.map((item) => (
        `\n*${item.cantidad}* x *${item.titulo}* ------> ${moneda} *${item.cantidad * (esCuba ? item.precio_cup : item.precio)}*\n${item?.item}`
    ));
    const cartDatabase = cartItems.map((item) => (
        `${item.cantidad} x ${item.titulo}<br>${item?.item}`
    ));

    let noteMessage = '';
    let miDireccion = '';
    let laNota = '';
    let nomEmpresa = 'Cogelo Barato';
    let laWebEmpresa = 'https://cogelobarato.com/';
    let NumeroTelefono = '';

    if (name.trim() !== '') {
        noteMessage += `\n*Nombre:* ${name}`;
    }
    if (direccion.trim() !== '') {
        miDireccion += `*Dirección:*\n ${direccion}`;
    }
    if (numTelefono.trim() !== '') {
        NumeroTelefono += `*Telefono:* ${numTelefono}`;
    }
    if (noteText.trim() !== '') {
        laNota += `\n*Nota:* ${noteText}`;
    }
    if (codigo.trim() !== '') {
        noteMessage += `\n*Codigo :* ${codigo}\n*Descuento de :* ${moneda} ${descuentoActualizado}`;
    }

    const paymentMessage = paymentMethod === 'Efectivo' ? '*Pago en efectivo*' : '*Pago por transferencia bancaria (+ 10%)*';
    const paymentMessage2 = deliveryOption === 'delivery' ? '*Envio a domicilio*' : '*Recogida en el lugar*';

    const obtenerTipoDispositivo = () => {
        const userAgent = navigator.userAgent;
        if (/windows/i.test(userAgent)) return 'Windows';
        if (/macintosh|mac os x/i.test(userAgent)) return 'Mac';
        if (/linux/i.test(userAgent)) return 'Linux';
        if (/android/i.test(userAgent)) return 'Android';
        if (/iphone|ipad|ipod/i.test(userAgent)) return 'iOS';
        return 'Desconocido';
    };

    let dispositivo = obtenerTipoDispositivo();
    let totalGeneral = parseFloat(formattedTotalPrice) + recargoTransferencia + parseFloat(costMensajeria || 0);

    // === 1. Enviar a Base de Datos ===
    const monedaUsada = esCuba ? 'CUP' : 'USD';
    const metodoEntrega = esCuba
        ? (deliveryOption === 'pickup' ? 'Recogida en el lugar' : 'Envio a domicilio')
        : 'Envio internacional';

    let tipoPagoFinal = paymentMethod;
    if (!esCuba && paymentMethod === 'Zelle') {
        tipoPagoFinal = 'Zelle';
    } else if (esCuba && paymentMethod === 'Transferencia') {
        tipoPagoFinal = 'Transferencia (+ 10%)';
    } else if (esCuba && paymentMethod === 'Efectivo') {
        tipoPagoFinal = 'Efectivo';
    }

    const dataBD = {
        estado: 'Pendiente',
        productos: JSON.stringify(cartDatabase),
        total: totalGeneral.toFixed(2),
        nota: noteText,
        nombre: name,
        telefono: numTelefono,
        direccion: direccion,
        tipoPago: tipoPagoFinal,
        precioMensajeria: costMensajeria || '0',
        empresa: nomEmpresa,
        dispositivo: dispositivo,
        moneda: monedaUsada,
        metodoEntrega: metodoEntrega
    };

    try {
        await axios.post('https://workspace.cogelobarato.com/addCompra.php', dataBD);
    } catch (error) {
        console.error('Error al guardar en BD:', error);
        toast.error('Error al procesar el pedido. Intente nuevamente.');
        return;
    }

    // === 2. Enviar a Telegram ===
    const productosParaTelegram = cartItems.map(item => ({
        titulo: item.titulo,
        cantidad: item.cantidad,
        item: Array.isArray(item.item) ? item.item : [item.item],
        precio: (esCuba ? item.precio_cup : item.precio)
    }));

    const dataTelegram = {
        nombre: name,
        telefono: numTelefono,
        direccion: direccion,
        nota: noteText,
        metodoEntrega: metodoEntrega,
        tipoPago: tipoPagoFinal,
        productos: productosParaTelegram,
        total: totalGeneral.toFixed(2),
        moneda: monedaUsada,
        empresa: nomEmpresa,
        dispositivo: dispositivo,
        mensajeria: costMensajeria || '0'
    };

    try {
        await fetch('https://cogelobarato.com/telegram/enviar_pedido_telegram.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataTelegram)
        });
    } catch (error) {
        console.error('Error al enviar a Telegram:', error);
        // No bloqueamos el flujo, solo registramos
    }

    // === 3. Enviar a WhatsApp ===
    let mensajeMensajeria = '';
    if (deliveryOption === 'delivery') {
        mensajeMensajeria = `\n*Mensajeria: ${moneda} ${costMensajeria} ${esCuba ? "CUP" : "USD"}*`;
    }

    let mensajeRecargo = '';
    if (recargoTransferencia > 0) {
        mensajeRecargo = `\n*Recargo por transferencia (10%): ${moneda} ${recargoTransferencia.toFixed(2)} ${esCuba ? "CUP" : "USD"}*`;
    }

    const message = `${laWebEmpresa}\n\n${noteMessage}\n${NumeroTelefono}\n${miDireccion}${laNota}\n${paymentMessage2}\n${paymentMessage}\n\n*DETALLES DE SU ORDEN*\n------------------------------------------------------>\n${cartDetails.join('')}\n------------------------------------------------------>${mensajeRecargo}${mensajeMensajeria}\n\n*Total: ${moneda} ${totalGeneral.toFixed(2)} ${esCuba ? "CUP" : "USD"}*`;

    const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

    clearCart();
    window.open(whatsappUrl, '_blank');
    setName('');
    setDireccion('');
    setNoteText('');
    setCodigo('');
    setDescuento(descuentoActualizado);
    setModalIsOpen(false);
    setModalIsOpen2(false);
};

    const increaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        updatedCartItems[index].cantidad += 1;
        setCartItems(updatedCartItems);
        localStorage.setItem('cart', JSON.stringify(updatedCartItems));
    };

    const decreaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        if (updatedCartItems[index].cantidad > 1) {
            updatedCartItems[index].cantidad -= 1;
            setCartItems(updatedCartItems);
            localStorage.setItem('cart', JSON.stringify(updatedCartItems));
        }
    };

    /* realizar pedidos------------------------*/
    const [mesas, setMesas] = useState([]);
    const [idMesa, setIdMesa] = useState('');
    const [estado, setEstado] = useState('Pendiente');
    const [mensaje, setMensaje] = useState('');
    const [selectedMesa, setSelectedMesa] = useState('');

    const cargarMesas = () => {
        fetch(`${baseURL}/mesaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setMesas(data.mesas || []);
            })
            .catch(error => console.error('Error al cargar mesas:', error));
    };

    const crearPedido = async () => {
        setMensaje('Procesando...');

        try {
            const productosPedido = cartItems.map(item => {
                return {
                    titulo: item.titulo,
                    cantidad: item.cantidad,
                    item: item.item,
                    categoria: item.categoria,
                    precio: item.precio,
                    imagen: obtenerImagen(item)
                };
            });
            const productosPedidoJSON = JSON.stringify(productosPedido);
            let totalPrice = 0;
            cartItems.forEach(item => {
                totalPrice += item.precio * item.cantidad;
            });

            const codigoDescuento = codigos.find(item => item.codigo === codigo);
            let descuentoCodigo = 0;
            if (codigoDescuento) {
                descuentoCodigo = codigoDescuento.descuento;
            }
            const totalPriceWithDiscount = totalPrice - descuentoCodigo;

            const formData = new FormData();
            formData.append('idMesa', idMesa);
            formData.append('estado', estado);
            formData.append('productos', productosPedidoJSON);
            formData.append('total', totalPriceWithDiscount);
            formData.append('nombre', name);
            formData.append('nota', noteText);
            formData.append('codigo', codigo);

            const response = await fetch(`${baseURL}/pedidoPost.php`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();
            if (data.mensaje) {
                setMensaje('');
                Swal.fire('Pedido enviado!', data.mensaje, 'success');
                setName('');
                setCodigo('');
                setNoteText('');
                cargarMesas();
                closeModal();
                closeModal2();
                closeModal3();
                clearCart();
            } else if (data.error) {
                setMensaje('');
                toast.error(data.error, { autoClose: 1000 });
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            toast.error('Error de conexión. Por favor, inténtelo de nuevo.', { autoClose: 1000 });
        }
    };

    const [counter, setCounter] = useState(contador);
    const [isPaused, setIsPaused] = useState(false);
    useEffect(() => {
        const interval = setInterval(() => {
            if (!isPaused) {
                setCounter((prevCounter) => {
                    if (prevCounter === 1) {
                        recargar();
                        return contador;
                    }
                    return prevCounter - 1;
                });
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [isPaused]);

    const togglePause = () => {
        setIsPaused(!isPaused);
    };

    const recargar = () => {
        cargarMesas();
    };

    // Si es recogida en el local, resetear costMensajeria a "0"
    useEffect(() => {
        if (esCuba && deliveryOption === 'pickup') {
            setcostMensajeria("0");
        }
    }, [deliveryOption, esCuba]);

    return (
        <div>
            <ToastContainer />
            <button onClick={openModal} className='cartIconFixed'>
                {cartItems?.length >= 1 && <span>{cartItems.length}</span>}
                <FontAwesomeIcon icon={faShoppingCart} />
            </button>

            <Modal
                isOpen={modalIsOpen}
                className="modal-cart"
                overlayClassName="overlay-cart"
                onRequestClose={closeModal}
            >
                <div className='deFLex'>
                    <button onClick={closeModal}><FontAwesomeIcon icon={faArrowLeft} /></button>
                    <MiPedido />
                    <button onClick={clearCart} className='deleteToCart'>Vaciar carrito</button>
                </div>
                {cartItems?.length === 0 ? (
                    <p className='nohay'> No hay productos</p>
                ) : (
                    <>
                        <div className="modal-content-cart">
                            {loading ? (
                                <p>Cargando...</p>
                            ) : (
                                <div>
                                    {cartItems.map((item, index) => (
                                        <div key={item?.idProducto} className='cardProductCart'>
                                            <Anchor to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`} onClick={closeModal}>
                                                <img src={obtenerImagen(item)} alt="imagen" />
                                            </Anchor>
                                            <div className='cardProductCartText'>
                                                <h3>{item.titulo}</h3>
                                                <span>
                                                    {item?.item?.map((sabor, index) => (
                                                        <span key={index}> {sabor}</span>
                                                    ))}
                                                </span>
                                                <strong>{moneda} {esCuba ? item?.precio_cup : item?.precio} {esCuba ? "CUP" : "USD"}</strong>
                                            </div>
                                            <div className='deColumn'>
                                                <button onClick={() => removeFromCart(item.idProducto)} className='deleteCart'>
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                                <div className='deFlexCantidad'>
                                                    <button onClick={() => decreaseQuantity(index)}>-</button>
                                                    <span>{item.cantidad}</span>
                                                    <button onClick={() => increaseQuantity(index)}>+</button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className='deColumnCart'>
                            <h4>Total: {moneda} {totalPrice.toFixed(2)} {esCuba ? "CUP" : "USD"}</h4>
                            <div className='deFLexBtns'>
                                <button className='btnWpp' onClick={openModal2}>
                                    Realizar pedido por <img src={whatsappIcon} alt="WhatsApp" />
                                </button>
                            </div>
                        </div>

                        <Modal
                            isOpen={modalIsOpen2}
                            onRequestClose={closeModal2}
                            className="modal-cart"
                            overlayClassName="overlay-cart"
                        >
                            <div className='deFLex'>
                                <button onClick={closeModal2}><FontAwesomeIcon icon={faArrowLeft} /></button>
                                <h4>Agregar Detalles</h4>
                            </div>
                            <div className="modal-send-form">
                                <input
                                    type="text"
                                    id="name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder='Nombre persona que recibe'
                                />

                                <textarea
                                    placeholder="Direccion detallada..."
                                    value={direccion}
                                    onChange={(e) => setDireccion(e.target.value)}
                                />
                                <input
                                    type="text"
                                    id="telefono"
                                    value={numTelefono}
                                    onChange={(e) => setNumTelefono(e.target.value)}
                                    placeholder='Telefono'
                                />

                                {esCuba && (
                                    <div className='deFLexRadio' style={{ display: 'flex' }}>
                                        <label>Opciones de entrega</label>
                                        <div>
                                            <input
                                                type="radio"
                                                id="delivery"
                                                name="deliveryOption"
                                                value="delivery"
                                                checked={deliveryOption === 'delivery'}
                                                onChange={() => setDeliveryOption('delivery')}
                                            />
                                            <label htmlFor="delivery">Envío a domicilio</label>
                                        </div>
                                        <div>
                                            <input
                                                type="radio"
                                                id="pickup"
                                                name="deliveryOption"
                                                value="pickup"
                                                checked={deliveryOption === 'pickup'}
                                                onChange={() => setDeliveryOption('pickup')}
                                            />
                                            <label htmlFor="pickup">Recogida en el lugar</label>
                                        </div>
                                    </div>
                                )}

                                <div className='deFLexRadio'>
                                    <label>Formas de pago</label>
                                    <div>
                                        {esCuba ? (
                                            <>
                                                <input
                                                    type="radio"
                                                    id="transferencia"
                                                    name="paymentMethod"
                                                    value="Transferencia"
                                                    checked={paymentMethod === 'Transferencia'}
                                                    onChange={() => setPaymentMethod('Transferencia')}
                                                />
                                                <label htmlFor="transferencia">Transferencia (+ 10%)</label>

                                                <input
                                                    type="radio"
                                                    id="efectivo"
                                                    name="paymentMethod"
                                                    value="Efectivo"
                                                    checked={paymentMethod === 'Efectivo'}
                                                    onChange={() => setPaymentMethod('Efectivo')}
                                                />
                                                <label htmlFor="efectivo">Efectivo</label>
                                            </>
                                        ) : (
                                            <>
                                                <input
                                                    type="radio"
                                                    id="zelle"
                                                    name="paymentMethod"
                                                    value="Zelle"
                                                    checked={paymentMethod === 'Zelle'}
                                                    onChange={() => setPaymentMethod('Zelle')}
                                                />
                                                <label htmlFor="zelle">Zelle</label>
                                            </>
                                        )}
                                    </div>
                                </div>

                                <textarea
                                    placeholder="Agrege detalles de su pedido, o puntos de refencia de la dirección"
                                    value={noteText}
                                    onChange={(e) => setNoteText(e.target.value)}
                                />

                                {esCuba === null ? (
                                    <p style={{ textAlign: 'center', color: '#666' }}>Detectando ubicación...</p>
                                ) : (
                                    <>
                                        {esCuba && deliveryOption === 'delivery' && (
                                            <select
                                                value={costMensajeria}
                                                onChange={(e) => setcostMensajeria(e.target.value)}
                                                name="mensajeria"
                                                style={{ padding: '10px', fontSize: '16px', width: '100%', borderRadius: '8px', border: '1px solid #ccc' }}
                                            >
                                                <option value="">SELECCIONES UN LUGAR DE ENTREGA</option>
                                                <option value="700">San Miguel del Padron - Siboney (700)</option>
                                                <option value="600">San Miguel del Padron - San Francisco (600)</option>
                                                <option value="600">San Miguel del Padron - La Rosita (600)</option>
                                                <option value="500">San Miguel del Padron - Diezmero (500)</option>
                                                <option value="400">San Miguel del Padron - Veracruz (400)</option>
                                                <option value="300">San Miguel del Padron - La Cumbre (300)</option>
                                                <option value="300">San Miguel del Padron - San Matias (300)</option>
                                                <option value="400">San Miguel del Padron - El Lucero (400)</option>
                                                <option value="600">San Miguel del Padron - California (600)</option>
                                                <option value="600">San Miguel del Padron - Loma de los Zapotes (600)</option>
                                                <option value="700">San Miguel del Padron - Virgen del Camino (700)</option>
                                                <option value="1000">San Miguel del Padron - La Cuevita (1000)</option>
                                                <option value="1000">San Miguel del Padron - Barrio Obrero (1000)</option>
                                                <option value="1000">San Miguel del Padron - Martin Perez (1000)</option>
                                                <option value="1500">San Miguel del Padron - Otras Zonas (1500)</option>
                                                <option value="2000">La Habana (2000)</option>
                                                <option value="2000">Cerro (2000)</option>
                                                <option value="1500">Guanabacoa (1500)</option>
                                                <option value="1500">Regla (1500)</option>
                                                <option value="1500">Cotorro (1500)</option>
                                                <option value="1000">Dies de Octubre (1000)</option>
                                                <option value="1000">Arrollo Naranjo (1000)</option>
                                                <option value="1500">Arrollo Naranjo - Electrico (1500)</option>
                                                <option value="3500">Cojimar (3500)</option>
                                                <option value="3500">Alamar (3500)</option>
                                                <option value="4000">Habana del Este (4000)</option>
                                                <option value="4500">Habana del Este - Guanabo (4500)</option>
                                                <option value="2000">Plaza de la Revolucion (2000)</option>
                                                <option value="2500">Playa (2500)</option>
                                                <option value="3000">Marianao (3000)</option>
                                                <option value="4500">La Lisa (4500)</option>
                                            </select>
                                        )}

                                        {esCuba && deliveryOption === 'pickup' && (
                                            <input
                                                type="text"
                                                id="informacion"
                                                disabled
                                                value="Recogida en el local - Sin costo de mensajería"
                                            />
                                        )}

                                        {!esCuba && (
                                            <select
                                                value={costMensajeria}
                                                onChange={(e) => setcostMensajeria(e.target.value)}
                                                name="mensajeria"
                                                style={{ padding: '10px', fontSize: '16px', width: '100%', borderRadius: '8px', border: '1px solid #ccc' }}
                                            >
                                                <option value="">SELECCIONES UN LUGAR DE ENTREGA</option>
                                                <option value="10">En la Habana - 10 USD</option>
                                            </select>
                                        )}

                                        {errorGeo && (
                                            <p style={{ color: 'red', fontSize: '14px', textAlign: 'center' }}>
                                                {errorGeo}
                                            </p>
                                        )}
                                    </>
                                )}

                                <input
                                    type="text"
                                    id="informacion"
                                    disabled
                                    value={`El costo de mensajería es: ${costMensajeria || '0'} ${esCuba ? "CUP" : "USD"}`}
                                />
                                <button onClick={handleWhatsappMessage} className='btn'>Enviar</button>
                            </div>
                        </Modal>

                        <Modal
                            isOpen={modalIsOpen3}
                            onRequestClose={closeModal3}
                            className="modal-cart"
                            overlayClassName="overlay-cart"
                        >
                            <div className='deFLex'>
                                <button onClick={closeModal3}><FontAwesomeIcon icon={faArrowLeft} /></button>
                                <h4>Elige tu mesa</h4>
                            </div>
                            <div className="modal-send-form">
                                <input
                                    type="text"
                                    id="name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder='Nombre'
                                />
                                <input
                                    type="text"
                                    id="codigo"
                                    value={codigo}
                                    onChange={(e) => setCodigo(e.target.value)}
                                    placeholder='Codigo de descuento (opcional)'
                                />
                                <textarea
                                    placeholder="Agrega una nota (opcional)"
                                    value={noteText}
                                    onChange={(e) => setNoteText(e.target.value)}
                                />
                                <div className='mesasGrapCart'>
                                    {mesas.map(item => (
                                        <div
                                            key={item.idMesa}
                                            className={`mesaCard ${item.estado === 'libre' ? (selectedMesa === item.idMesa ? 'selectedMesa' : 'bg-green') : 'bg-red'}`}
                                            onClick={() => { if (item.estado === 'libre') setIdMesa(item.idMesa) }}
                                        >
                                            <label>{item.mesa}</label>
                                            <span>
                                                {item.estado === 'libre' ? (selectedMesa === item.idMesa ? 'selected' : '') : 'ocupada'}
                                            </span>
                                            {item.estado === 'libre' && (
                                                <input
                                                    type='radio'
                                                    name='productos'
                                                    value={item.idMesa}
                                                    readOnly
                                                    checked={idMesa === item.idMesa}
                                                />
                                            )}
                                        </div>
                                    ))}
                                </div>

                                <fieldset className='deNonefieldset'>
                                    <legend>Productos</legend>
                                    <textarea
                                        name='productos'
                                        value={cartItems.map(item => ` ${item.categoria}, ${item.titulo}, x ${item.cantidad}, ${item.item},${item.categoria},${item.precio}, ${obtenerImagen(item)}  `).join('\n')}
                                        readOnly
                                    />
                                </fieldset>
                                {mensaje ? (
                                    <button type='button' className='btn' disabled>
                                        {mensaje}
                                    </button>
                                ) : (
                                    <button type='button' onClick={crearPedido} className='btn'>
                                        Finalizar pedido
                                    </button>
                                )}
                            </div>
                        </Modal>
                    </>
                )}
            </Modal>
        </div>
    );
}